import * as React from 'react';
import {Content, GenericSectionWrapper, Title} from './GenericSectionStyles';
import {language} from './GenericSectionLanguage'

export type Props = {
	section: any;
};

export const GenericSectionLayout = (props: Props) =>
{
	const render = () =>
	{
		const returnValue = (
			<GenericSectionWrapper>
				<Title>
					{props.section.title}
				</Title>
				<Content>
					{props.section.content}
				</Content>
			</GenericSectionWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
